<template>
    <div
        :class="minimal ? '' : 'py-20'"
        class="relative w-full bg-black border-t border-gray-700"
    >
        <div class="relative px-4 py-10 mx-auto max-w-7xl sm:px-6 rounded-xl">
            <div
                v-if="!minimal"
                class="grid grid-cols-3 gap-4 text-sm text-gray-500 md:grid-cols-5"
            >
                <div
                    v-for="menu in mainMenu"
                    :key="menu.name"
                >
                    <h3 class="mb-2 text-gray-300">
                        {{ menu.name }}
                    </h3>
                    <ul>
                        <li
                            v-for="item in menu.subMenu"
                            :key="item.name"
                            class="py-2 md:py-1"
                        >
                            <component
                                :is="item.href.startsWith('https://') ? 'a' : 'router-link'"
                                :href="item.href"
                                :to="item.href"
                                class="hover:text-gray-300 hover:underline"
                            >
                                {{ item.name }}
                            </component>
                        </li>
                    </ul>
                </div>
                <!--
                <div class="col-span-3 md:col-span-2">
                    <div class="p-6 mt-4 rounded-lg shadow md:mt-0 bg-gray-50">
                        <h3 class="text-lg font-medium leading-6 text-gray-900">
                            Get new release discounts
                        </h3>
                        <div class="max-w-xl mt-2 text-sm text-gray-500">
                            <p>
                                Subscribe to get notifications of new releases and discounts.
                            </p>
                        </div>
                        <ActiveCampaignForm
                            form-id="19"
                            input-width="w-full"
                            label="Subscribe"
                            list="f5664c0f5bac7d70c29b14255c12e8c9"
                            placeholder="you@example.com"
                        >
                            <template #success>
                                <p class="p-2 leading-6 text-gray-900 bg-white border-l-4 border-green-500 rounded">
                                    <CheckCircleIcon
                                        aria-hidden="true"
                                        class="inline-block w-5 h-5 mr-2 text-green-500"
                                    />
                                    You have been subscribed!
                                </p>
                            </template>
                            <template #error-message>
                                <p>Error, please try again.</p>
                            </template>
                        </ActiveCampaignForm>
                    </div>
                </div>
        -->
            </div>
            <div
                class="flex flex-wrap justify-between pt-5 mt-10 mb-5 text-sm text-gray-300 border-t border-gray-700 lg:flex-nowrap gap-y-4"
            >
                <div class="">
                    Copyright © 2015-{{ new Date().getFullYear() }} Visual Design Cafe.
                    All rights reserved.
                </div>
                <div
                    class="grid w-full grid-cols-2 gap-4 divide-gray-700 md:w-auto md:divide-x md:flex md:grid-cols-4"
                >
                    <div
                        v-for="(item, index) in secondMenu"
                        :key="item.name"
                        :class="index > 0 ? 'md:pl-4' : ''"
                        class="inline-flex text-center whitespace-nowrap"
                    >
                        <component
                            :is="item.href.startsWith('https://') ? 'a' : 'router-link'"
                            :href="item.href"
                            :to="item.href"
                            class="hover:underline"
                        >
                            {{ item.name }}
                        </component>
                    </div>
                </div>
            </div>
            <div
                v-if="!minimal"
                class="mt-2 text-sm text-gray-500"
            >
                This website is not sponsored by or affiliated with Unity Technologies
                or its affiliates. “Unity” is a trademark or registered trademark of
                Unity Technologies or its affiliates in the U.S. and elsewhere.
            </div>
            <div
                v-if="!minimal"
                class="mt-2 text-sm text-gray-500"
            >
                We use affiliate links and receive a commission when you make a purchase
                after clicking a link to the Unity Asset Store.
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>

const props = defineProps({
    minimal: Boolean
});

const mainMenu = [
    {
        name: "Nature Renderer",
        subMenu: [
            {
                name: "Overview",
                href: "/nature-renderer/"
            },
            {
                name: "Pricing",
                href: "/nature-renderer/pricing"
            },
            {
                name: "Documentation",
                href: "/nature-renderer/docs"
            },
            {
                name: "Issue Tracker",
                href: "https://github.com/visualdesigncafe/nature-renderer/issues"
            },
            {
                name: "Forum",
                href: "https://github.com/visualdesigncafe/nature-renderer/discussions"
            }
        ]
    },
    {
        name: "Nature Shaders",
        subMenu: [
            {
                name: "Overview",
                href: "/nature-shaders/"
            },
            {
                name: "Documentation",
                href: "/nature-shaders/docs"
            },
            {
                name: "Issue Tracker",
                href: "https://github.com/visualdesigncafe/nature-shaders/issues"
            },
            {
                name: "Forum",
                href: "https://github.com/visualdesigncafe/nature-shaders/discussions"
            }
        ]
    },
    {
        name: "3D Models",
        subMenu: [
            {
                name: "Realistic Nature",
                href: "/realistic-nature/"
            },
            {
                name: "Stylized Nature",
                href: "/stylized-nature/"
            }
        ]
    },
    {
        name: "Social",
        subMenu: [
            {
                name: "Twitter",
                href: "https://twitter.com/VDCafe"
            },
            {
                name: "Youtube",
                href: "https://www.youtube.com/channel/UCLsdWcw6r8D45bIh-4uUB1A"
            }
        ]
    }
];

const secondMenu = [
    {
        name: "Privacy Policy",
        href: "/legal/privacy-policy/"
    },
    {
        name: "Terms of Service",
        href: "/legal/terms-of-service/"
    },
    {
        name: "EULA",
        href: "/legal/eula/"
    }
    /*
      {
        name: "Sales and Refunds",
        href: "#",
      },
      {
        name: "Legal",
        href: "#",
      },
      */
];

</script>
